var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title is-3 mb-3",class:{ 'is-hidden-mobile': _vm.isHiddenMobile }},[_vm._v("\n  "+_vm._s(_vm.caption)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }